<template>
  <div class="form-content">
    <ProductList v-bind:applicationId="applicationId"/>
    <router-view/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ProductList from '@/components/ProductList.vue';

/**
 * Rebate Application Form
 *
 * Houses a ProductList and a router view that can be used to display different forms.
 */
export default {
  components: {
    ProductList,
  },
  props: {
    /**
     * The ID for the application this product list is related to. Used to fetch
     * the product information
     */
    applicationId: String,
  },
  computed: {
    ...mapGetters('language', ['getCurrentLanguage']),
  },
  methods: {
    /**
     * Requests the utility configuration from the backend and sets the
     * CMS Host
     */
    getUtilityConfig() {
      this.$store.dispatch(
        'siteSettings/setCurrentUtility',
        { applicationId: this.applicationId },
      ).then(() => this.$store.dispatch('cmsText/updateText', {
        utilityID: this.$store.state.siteSettings?.settings?.rebateConfig?.utilityID,
        language: this.getCurrentLanguage,
      }));
    },
    getRebateApplicationForms() {
      this.$store.dispatch(
        'forms/setCurrentForms',
        { applicationId: this.applicationId, language: this.getCurrentLanguage },
      );
    },
  },
  created() {
    this.getUtilityConfig();
    this.getRebateApplicationForms();
  },
};
</script>
